import React, { ReactElement } from 'react'
import StepFileUpload from '../upload/StepFileUpload'
import useUploadHook from '../../hooks/UseUploadHook'
import { IUploadProps } from '../../interfaces/Upload'
import LocativeText from './LocativeText'

const index = 0
function LocativeAssociationUpload(props: IUploadProps): ReactElement {
  const { state, setState, validateFile, isPeriodicRemediation } = props
  const { uploadFile } = useUploadHook({
    index,
    setState,
    mainState: state,
    validateFile,
    isPeriodicRemediation,
  })
  const { toggleValidateButton, validationButtonError } = state[index]

  return (
    <div className="col12 mt6md mt3">
      <p className="mb3">
        En tant qu’hébergé, pour déclarer votre lieu de vie, nous avons besoin
        de recueillir une attestation d’hébergement de la part de la structure
        qui vous héberge.
      </p>
      <LocativeText />
      <div className="row">
        <div className="mw77 wFull pr3lg">
          <p className="mb3">
            Veuillez nous transmettre une attestation d’hébergement.
          </p>
          <div className="row">
            <StepFileUpload
              {...{
                ...props,
                index,
                title: 'Attestation d’hébergement',
                loadingSpinnerClassName: 'dFlex justifyContentEnd mt1',
                className: 'col12',
              }}
            />
          </div>
          <div className="row">
            <StepFileUpload
              {...{
                ...props,
                title: 'Justificatif de domicile de l’hébergeur',
                fileIndex: 1,
                tooltip: 'justificatifHeberge',
                index,
                className: 'col12',
              }}
            />
          </div>
        </div>
      </div>
      {toggleValidateButton && (
        <div className="row">
          <div className="wFull mw77 dFlex justifyContentEnd flexWrap pr3lg">
            <button
              className="btn btnPrimary btnPrimaryMd wFull wAutoMd"
              type="button"
              onClick={uploadFile}
            >
              Valider les documents
            </button>
            {validationButtonError && (
              <p
                className={`${validationButtonError.type}Error wFull mt1 textRight`}
              >
                {validationButtonError.message}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default LocativeAssociationUpload
